export default function Footer() {
  const groups = [
    { title: "看新瓜", links: ["今日热瓜", "首发速递", "今日更新", "新料图鉴"] },
    { title: "各分区", links: ["综艺圈", "影剧圈", "直播圈", "商务瓜"] },
    { title: "关于本站", links: ["免责声明", "投稿与爆料", "侵权处理", "联系我们"] },
  ];

  return (
    <footer id="report" className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-foreground-950 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <h4 className="text-xl font-extrabold tracking-tight text-foreground-950">最全黑料</h4>
            </a>
            <p className="mt-3 text-sm leading-relaxed text-secondary-700">
              最全黑料新瓜每日刷新，今日更新内容首发速递。收藏本站，每天来看刷新列表，不落下任何一条新料。
            </p>
            <a
              href="#report"
              className="mt-4 flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              <i className="ri-edit-2-fill text-sm" />
              我要爆料
            </a>
          </div>

          {groups.map((g) => (
            <div key={g.title}>
              <h4 className="text-sm font-bold text-foreground-950">{g.title}</h4>
              <ul className="mt-3 space-y-2.5">
                {g.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-sm text-secondary-700 hover:text-primary-600">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl bg-background-50/70 px-5 py-4">
          <p className="text-xs leading-relaxed text-secondary-600">
            免责声明：本站内容均为网友投稿与公开讨论信息整理，人物均为虚构题材，仅供娱乐参考，不构成任何事实结论。
            请理性吃瓜、友善讨论。若涉及侵权，请通过上方「侵权处理」联系我们，我们会在核实后及时处理。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-600">© 2026 最全黑料 · 今日新瓜首发速递抢先看</p>
          <div className="flex items-center gap-4">
            <a href="#top" className="flex items-center gap-1 text-xs text-secondary-600 hover:text-primary-600">
              <i className="ri-bookmark-fill text-xs" />
              收藏本站
            </a>
            <a
              href="#top"
              className="flex h-8 w-8 items-center justify-center rounded-full border border-background-200 bg-background-50 text-secondary-700 hover:text-primary-600"
            >
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}